module.exports = __webpack_public_path__ + "static/media/44452933_2199896326752213_2172409533652008960_o.d7fa935d.jpg";